export default {
    // Blues
    "blue": "#2970FF",
    "blue-dark": "#1A46A9",
    "blue-darkest": "#091440",
    "blue-zodiac": "#18234D",
    // Greys
    "grey-jet": "#5F6683",
    "grey-lighter": "#E4E6EA",
    "grey-light": "#ABAEBE",
    "grey": "#787F98",
    "grey-regent": "#9196AA",
    "grey-rhino-light": "#3F486B",
    "grey-rhino": "#2B355B",
    "grey-smokey": "#707070",
    // White
    "white": "#fff",
    "white-ghost": "#CACDD6",
    "red": "#FF2929",
    // Font
    "font-color": "var(--white)",
    "font-size-sm": "10px",
    "font-size-md": "13px",
    "font-size-lg": "15px",
    "font-size-xl": "21px",
    // Layout
    "bg-color": "var(--blue-darkest)",
    // Header
    "header-bg-color": "var(--bg-color)",
    "header-bg-gradient": "transparent linear-gradient(220deg, #09144066 0%, #091440E3 83%, #091440E3 100%) 0% 0% no-repeat padding-box",
    "header-lang-toggle-color": "#F7F7F98C",
    // Menu
    "menu-active-color": "var(--white)",
    // Main Card
    "main-card-bg-color": "var(--blue-zodiac)",
    "main-card-heading-color": "var(--grey-jet)",
    "main-card-heading-line-color": "var(--grey-rhino)",
    // Footer
    "footer-bg-color": "var(--bg-color)",
    "sm-color": "var(--white)",
    // File Inout
    "file-input-border-color": "var(--grey)",
    "file-input-hover-bg-color": "#1f2952",
    // Latest Hash
    "latest-hash-section-bg-color": "var(--blue-zodiac)",
    "latest-hash-timeago-color": "var(--grey)",
    "latest-hash-hover-color": "var(--white)",
    // Button
    "button-primary-bg-color": "var(--blue)",
    "button-primary-bg-hover-color": "var(--blue-dark)",
    "button-primary-color": "var(--white)",
    "button-disabled-bg-color": "var(--grey-jet)",
    "button-disabled-color": "var(--grey-regent)",
    "button-secondary-bg-color": "var(--grey-rhino-light)",
    "button-secondary-bg-hover-color": "var(--grey-rhino)",
    "button-secondary-color": "var(--white)",
    "button-tertiary-color": "#E4E6EA",
    "button-tertiary-border-color": "#3F486B",
    "button-tertiary-border-hover-color": "#E4E6EA",
    // Input
    "input-bg-color": "var(--blue-darkest)",
    "input-placeholder-color": "var(--grey)",
    "input-hover-border-color": "#FFFFFF57",
    // Search
    "search-icon-hover-color": "var(--white)",
    "search-input-placeholder-color": "var(--white)",
    // Hash view
    "status-color": "var(--grey)",
    "go-back-color": "var(--grey)",
    // Tooltip
    "tooltip-bg-color": "var(--grey-rhino-light)",
    "tooltip-hover-color": "var(--grey-regent)",
    // Icons
    "button-icon-hover-bg-color": "#ffffff15",
    "button-icon-hover-color": "var(--white)",
    "copy-to-clipboard-color": "var(--grey)",
    "checkbox-color": "var(--grey)",
    "checkbox-check-color": "var(--white)",
    // Progress bar
    "progress-bar-border-color": "var(--white)",
    "progress-bar-bg-color": "var(--grey-rhino-light)",
    "progress-bar-bg-color-step": "var(--grey)",
    "progress-bar-bg-color-done": "var(--blue)",
    // Spinner
    "spinner-border": "rgba(255, 255, 255, 0.3)",
    "spinner-border-top": "var(--white)",
    // Toast
    "toast-bg-color": "var(--blue-darkest)"
};